export default {"src":"/_next/static/media/whatsapp-fill.6fc47bc9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};